import "@/assets/styles/howest-theme.scss";
import "@/assets/styles/ap-theme.scss";
import "@/assets/styles/ehb-theme.scss";
import "@/assets/styles/hzs-theme.scss";
import "@/assets/styles/pxl-theme.scss";
import "@/assets/styles/tm-theme.scss";
import "@/assets/styles/multiselect.scss";
import "flatpickr/dist/flatpickr.css";
import Vue from "vue";
import "bootstrap";
import HomeComponent from "@/app/home.vue";

import MijnDossier from "./mijnDossier/MijnDossier.vue";
import MijnDocumenten from "./mijnDocumenten/MijnDocumenten.vue";
import MijnNbe from "./mijnNBE/MijnNbe.vue";
import OpdrachtenModule from "./opdrachten-module/OpdrachtenModule.vue"
import PhotoModule from "./photo-module/PhotoModule.vue"

import LoginComponent from "./Login.vue";
import AccessDenied from "./AccessDenied.vue";
import ResetPassword from "./ResetPassword.vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFolderOpen,
  faHome,
  faCalculator,
  faUsers,
  faSignIn,
  faMoneyBillWaveAlt,
  faIdCard,
  faPhone,
  faUserFriends,
  faEllipsisH,
  faFilesMedical,
  faDownload,
  faEdit,
  faTrash,
  faSave,
  faCalendar,
  faPen,
  faUndo,
  faGripLines,
  faGripHorizontal,
  faFileUpload,
  faUpload,
  faPaperclip,
  faSignOut,
  faUserPlus,
  faPhonePlus,
  faExclamation,
  faBell,
  faUser,
  faUserCog,
  faEye,
  faEyeSlash,
  faQuestion,
  faEnvelope,
  faInfoCircle,
  faCheckCircle,
  faFileAlt,
  faTasks,
  faThLarge,
  faMoneyCheckEdit,
  faEuroSign,
  faMoneyBill,
  faHistory,
  faExchange,
  faImagePortrait,
  faIslandTropical,
  faBuilding,
  faPause,
  faCirclePause,
  faBooks,
  faFilter,
  faReceipt,
  faUniversity,
  faList,
  faLink,
  faChevronsLeft,
  faChevronsRight,
  faFilterCircleXmark,
} from "@fortawesome/pro-duotone-svg-icons";
import {
  faFolderOpen as faFolderOpenRegular,
  faTimes,
  faTrashAlt,
  faPlus,
  faCheck,
  faChevronDown,
  faChevronUp,
  faArrowLeft,
  faEraser,
  faExternalLink,
} from "@fortawesome/pro-regular-svg-icons";
import { faCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import flatPickr from "vue-flatpickr-component";
import Vuelidate from "vuelidate";

//Directives
import { Tooltip } from "./directives/tooltip";
Vue.directive("tooltip", Tooltip);

Vue.use(Vuelidate);
Vue.component("flat-pickr", flatPickr);

library.add(
  faArrowLeft,
  faBell,
  faBooks,
  faBuilding,
  faCalculator,
  faCalendar,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faCircle,
  faDownload,
  faEdit,
  faEllipsisH,
  faEnvelope,
  faEraser,
  faEuroSign,
  faExchange,
  faExclamation,
  faEye,
  faEyeSlash,
  faFileAlt,
  faFilesMedical,
  faFileUpload,
  faFilter,
  faFolderOpen,
  faFolderOpenRegular,
  faGripHorizontal,
  faGripLines,
  faHistory,
  faHome,
  faIdCard,
  faImagePortrait,
  faInfoCircle,
  faIslandTropical,
  faLink,
  faList,
  faMoneyBill,
  faMoneyBillWaveAlt,
  faMoneyCheckEdit,
  faPaperclip,
  faPause,
  faCirclePause,
  faPen,
  faPhone,
  faPhonePlus,
  faPlus,
  faQuestion,
  faReceipt,
  faSave,
  faSignIn,
  faSignOut,
  faTasks,
  faThLarge,
  faTimes,
  faTrash,
  faTrashAlt,
  faUndo,
  faUniversity,
  faUpload,
  faUser,
  faUserCog,
  faUserFriends,
  faUserPlus,
  faUsers,
  faChevronsLeft,
  faChevronsRight,
  faFilterCircleXmark,
  faExternalLink,
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
new Vue({
  el: "#app",
  components: {
    HomeComponent,
    MijnDossier,
    LoginComponent,
    ResetPassword,
    AccessDenied,
    MijnDocumenten,
    OpdrachtenModule,
    MijnNbe,
    PhotoModule,
  },
});
